import { render } from "./imageShowCanvas.vue?vue&type=template&id=c962db42&scoped=true"
import script from "./imageShowCanvas.vue?vue&type=script&lang=js"
export * from "./imageShowCanvas.vue?vue&type=script&lang=js"

import "./imageShowCanvas.vue?vue&type=style&index=0&id=c962db42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c962db42"

export default script